import styled from 'styled-components'

const headerSize = 120
const footerSize = 440

const Main = styled.main`
	display: block;
	position: relative;
	width: 100%;
	display: flex;
	flex: 1;
	justify-content: center;
	min-height: 60vh;

	${p =>
		!p.onHomepage &&
		p.theme.above('medium')`
		min-height: calc(100vh - ${footerSize + headerSize}px);
	`}

	${p =>
		p.noRightSidebar &&
		p.theme.above('extraLarge')`
		margin-left: 96px;
	`}

  ${p =>
		p.fullWidth &&
		`
    grid-column: 2 / 4;
  `}
`

export default Main
